import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Check, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

// UX-POLISH-01 #2: one shared "Save/success" button for every mutation-driven form in the app —
// spinner morphs into a checkmark on success (per UX_MOTION.md), then the caller closes/resets
// after a brief hold (pair with `useSuccessPulse`). Mirrors the pattern already proven in
// NewMemberDialog/ProvisionGymDialog, just DRY'd into one place instead of re-typed per dialog.
export function SubmitButton({
  testId, pending, success, label, savingLabel, successLabel, disabled, type = "button",
  onClick, className = "", style, variant, fullWidth = false,
}) {
  const reducedMotion = useReducedMotion();
  const status = success ? "success" : pending ? "saving" : "idle";
  const isFilled = !variant || variant === "default";
  return (
    <Button
      type={type}
      data-testid={testId}
      disabled={pending || success || disabled}
      onClick={onClick}
      variant={variant}
      className={`${isFilled ? "text-white" : ""} ${fullWidth ? "w-full" : ""} ${className}`}
      style={isFilled ? (style ?? { background: "var(--scarlet-accent)" }) : style}
    >
      <AnimatePresence mode="wait" initial={false}>
        {status === "saving" && (
          <motion.span key="saving" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={reducedMotion ? { duration: 0 } : undefined} className="flex items-center gap-2">
            <Loader2 size={16} className="animate-spin" /> {savingLabel || "Saving…"}
          </motion.span>
        )}
        {status === "success" && (
          <motion.span key="success" initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={reducedMotion ? { duration: 0 } : { type: "spring", stiffness: 300, damping: 15 }} className="flex items-center gap-2">
            <Check size={16} /> {successLabel || "Done"}
          </motion.span>
        )}
        {status === "idle" && <motion.span key="idle" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={reducedMotion ? { duration: 0 } : undefined}>{label}</motion.span>}
      </AnimatePresence>
    </Button>
  );
}
